
const Logo = ({ textAlign }) => {
  return (
    <>
      <h1 className={`${textAlign} text-xl font-bold text-linkedin-blue`}>Fractofolio</h1>
      <p className={`${textAlign} text-linkedin-blue font-regular text-xs`}>Stock Market Insights</p>
    </>
  );
};

export default Logo;
